<template>
  <section class="newTable">
    <table class="table datatable table-striped area-list-datatable" id="MedicalEDMDataTable">
      <thead>
        <tr>
          <th id="th_sel" :width="screenWidth * 0.08">
            <div class="checkbox checkbox-inline mr-0">
              <input
                @click="clickTarget = clickTarget == `clickAll`? `clickAll-again`: `clickAll`"
                type="checkbox"
                name="check-all"
                id="check-all"
                value="1"
                v-model="checkAll"
              />
              <label for="check-all"></label>
            </div>
            <span>#</span>
          </th>
          <th
            :width="screenWidth * 0.1"
            id="th_name"
            :class="'sorting ' + (order.fieldName == 'name' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
            @click="columnSorting('name')"
          >姓名</th>
          <th
            :width="screenWidth * 0.1"
            :class="'sorting ' + (order.index=='id' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
            @click="columnSorting('id')"
          >身分證</th>
          <th
            :width="screenWidth *  0.1"
            id="th_mobile"
            :class="'sorting ' + (order.fieldName == 'mobile' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
            @click="columnSorting('mobile')"
          >手機</th>
          <th
            :width="screenWidth *  0.1"
            id="th_home_tel"
            :class="'sorting ' + (order.fieldName == 'home_tel' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
            @click="columnSorting('home_tel')"
          >電話</th>
          <th
            :width="screenWidth *  0.08"
            :class="'sorting ' + (order.fieldName=='birthday' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
            @click="columnSorting('birthday')"
          >生日</th>
          <th
            :width="screenWidth * 0.15"
            id="th_edm"
            :class="'sorting ' + (order.fieldName == 'edm' ? (order.asc ? 'sorting_asc' : 'sorting_desc') : '')"
            @click="columnSorting('edm')"
          >公司寄發EDM</th>
          <th id="th_visit" :width="screenWidth * 0.09">排訪</th>
          <th width="*">拜訪回饋</th>
        </tr>
      </thead>
      <tbody class="block-height" :style="{height: height + 'px'}">
        <tr v-for="(d, did) in tableDataBackup" :key="`MedicalEDMDataTable-table-td-${did}`">
          <td :width="screenWidth * 0.08">
            <div style="min-height: 30px;">
              <div class="mr-0 checkbox checkbox-inline">
                <input
                  @click="clickTarget = clickTarget == `td-${did}`? `td-${did}-again`: `td-${did}`"
                  type="checkbox"
                  name="`td-item[]`"
                  :id="`MedicalEDMDataTable-check-${did}`"
                  :value="d.id"
                  v-model="selection"
                  :disabled="d.id === ''"
                  @change="$emit('update', selection)"
                />
                <label :for="`MedicalEDMDataTable-check-${did}`"></label>
              </div>
              <span>
                <span class="no">{{did + 1}}</span>
                <span class="info text-center">
                  <level :lv="Number(d.vip_level)" />
                  <avatar :gender="Number(d.sex)" :size="20" />
                </span>
              </span>
            </div>
          </td>
          <td :width="screenWidth * 0.1">
            <Tooltip
              :position="did < 3?'bottom':'top'"
              :name="d.name"
              :id="d.id"
              :mobile="d.mobile"
              :birthday="d.birthday"
            >
              <a
                v-if="d.is_exist"
                class="text-green text-underline pointer-cursor"
                @click="routerToCust(d.id, d.name)"
              >{{d.name | getMaskName}}</a>
              <a v-else>{{d.name | getMaskName}}</a>
            </Tooltip>
          </td>
          <td :width="screenWidth * 0.1">{{d.id | getMaskID}}</td>
          <td :width="screenWidth * 0.1">{{d.mobile | getMaskMobile}}</td>
          <td :width="screenWidth * 0.1">{{d.home_tel | getMaskMobile}}</td>
          <td :width="screenWidth * 0.08">
            <span>
              <div class="date">{{d.birthday | dateFormat | getMaskBirthday}}</div>
              <div class="age">
                <b>{{ d.age? d.age : '— —' }}</b>
                <span v-if="d.age">歲</span>
                <span v-else></span>
              </div>
            </span>
          </td>
          <td :width="screenWidth * 0.15">{{d.edm}}</td>
          <td v-if="isBox" :width="screenWidth * 0.09">
            <button
              v-if="!d.visit.csidno"
              type="button"
              class="btn btn-primary"
              @click="callBoxVisit(d)"
              v-html="'<span style=\'font-size:1.25rem\'>預約<span>'"
            ></button>
            <button
              v-else
              type="button"
              class="btn btn-primary"
              style="font-size:0.8rem;"
              @click="callBoxVisit(d)"
            >
              {{ d.visit.str_date | dateFormat }}
              <br />
              {{ d.visit.str_time }}
            </button>
          </td>
          <td v-else :width="screenWidth * 0.09">
            <button
              v-if="!d.visit.csidno"
              type="button"
              class="btn btn-primary"
              @click="$emit('scheduled-access', d)"
              v-html="'<span style=\'font-size:1.25rem\'>預約<span>'"
            ></button>
            <button
              v-else
              type="button"
              class="btn btn-primary"
              style="font-size:0.8rem;"
              @click="$emit('scheduled-access', d)"
            >
              {{ d.visit.str_date | dateFormat }}
              <br />
              {{ d.visit.str_time }}
            </button>
          </td>
          <td width="*">
            <a
              href="https://www.cathaylife.com.tw/website/PFWeb/servlet/HttpDispatcher/PFCF_0200/PromptA?ACT_NO=2021090601"
              target="_blank"
              class="btn btn-primary"
              style="font-size:1.25rem;"
            >進入填寫</a>
          </td>
        </tr>
        <tr v-if="tableDataBackup.length == 0">
          <td colspan="9" class="text-center pt-3 pb-5">
            <h3>無客戶名單資料</h3>
          </td>
          <td style="display: none;"></td>
          <td style="display: none;"></td>
          <td style="display: none;"></td>
          <td style="display: none;"></td>
          <td style="display: none;"></td>
        </tr>
      </tbody>
    </table>
  </section>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Level from "@/components/Level";
import Avatar from "@/components/Avatar";
import { commonMixin } from "@/mixins/common";
import { setTimeout } from "timers";
import Tooltip from "@/desktop/components/ToolTip";

export default {
  name: "MedicalEDMDataTable",
  mixins: [commonMixin],
  components: { Level, Avatar, Tooltip },
  props: {
    tableData: {
      type: Array,
      default: () => {
        return [];
      }
    },
    height: {
      type: Number,
      default: () => {
        return 350;
      }
    },
    //名單專區資訊
    categoryInfo: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      order: {
        fieldName: "name",
        asc: true
      },
      checkAll: false,
      clickTarget: "",
      tableDataBackup: [],
      allIdData: [],
      selection: [],
      screenWidth:
        document.body.clientWidth > 1208 ? 1280 : document.body.clientWidth,
      scrollHeight: 0
    };
  },
  computed: {
    ...mapGetters(["UserInfo"]),
    isBox() {
      //判斷是否為box
      return this.UserInfo.userType === "box";
    }
  },
  watch: {
    tableData: function() {
      this.init();
    },
    clickTarget: function(target) {
      if (target == "clickAll" || target == "clickAll-again") {
        //點了全選checkbox
        if (this.checkAll) {
          //點了全選
          this.selection = [];
          this.allIdData.forEach(data => {
            this.selection.push(data);
          });
        } else {
          //取消全選
          this.selection = [];
        }
      } else {
        //點了其他checkbox
        this.checkAll = this.selection.length == this.allIdData.length;
      }
      this.$emit("update", this.selection);
    }
  },
  methods: {
    ...mapActions(["setPageLock", "updateCustID"]),
    //處理排序
    columnSorting(fieldName) {
      //切換表頭圖案
      if (this.order.fieldName == fieldName) {
        this.order.asc = !this.order.asc;
      } else {
        this.order.fieldName = fieldName;
        this.order.asc = true;
      }

      if (fieldName == "name") {
        this.$emit("init", this.order.asc ? "1" : "2");
        return;
      }

      //data排序
      let sortOrder = -1;
      if (this.order.asc) {
        sortOrder = 1;
      }

      this.tableDataBackup = [];
      setTimeout(() => {
        this.tableDataBackup = [...this.tableData];
        this.tableDataBackup.sort(this.sortCompareFun(sortOrder, fieldName == "birthday" ? "birthdaySort" : fieldName));
        this.registerHanlink(); // for 難字更新
      }, 20);
    },
    sortCompareFun(sortOrder, property) {
      return function(a, b) {
        let result =
          a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
        return result * sortOrder;
      };
    },
    routerToCust(custID, custName) {
      if (this.isBox) {
        //若内嵌於Box, 將客戶資訊回傳給Box
        this.boxCustInfo(custID, custName);
      } else {
        this.updateCustID(custID);
        localStorage.CustID = custID;
        this.$router.push({ path: `/detail/CustID/tab/1` });
      }
    },
    init() {
      this.checkAll = false;
      this.selection = [];
      this.tableDataBackup = this.tableData.map(ele => {
        return ele;
      });
      this.allIdData = this.tableData.map(ele => {
        return ele.id;
      });
      this.registerHanlink(); // for hard word
    },
    callBoxVisit(data) {
      //連至Box排訪
      this.boxVisit(data, this.categoryInfo);
    },
  },
  mounted() {
    // 監聽視窗寬度
    const self = this;

    window.onresize = () => {
      return (() => {
        if (document.body.clientWidth > 1220) {
          window.screenWidth = 1220;
          self.screenWidth = 1220;
        } else {
          window.screenWidth = document.body.clientWidth;
          self.screenWidth = window.screenWidth;
        }
      })();
    };

    this.scrollHeight =
      parseInt($(window).height()) - $("tbody").offset().top - 85;
    $(window).bind("resize", function() {
      self.scrollHeight =
        parseInt($(window).height()) - $("tbody").offset().top - 85;
    });
    $(".tab-content").css("padding-bottom", "62px");
  }
};
</script>

<style lang="scss" scoped>
.newTable thead tr,
.newTable tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
  border-left: 0;
  border-right: 0;
  border-bottom: 0;

  td {
    word-break: break-all;
  }

  &.sorting,
  &.sorting_desc {
    position: relative;
    padding-right: 25px !important;

    &:before,
    &:after {
      content: "";
      position: absolute;
      width: 0px;
      height: 0px;
      display: block;
      top: 0;
      bottom: 0;
      right: 6px;
      margin: auto;
    }

    &:after {
      top: 18px;
      border-top: 6px solid transparentize(#027a39, 0.5);
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-bottom: 6px solid transparent;
    }

    &:before {
      top: -13px;
      border-bottom: 6px solid transparentize(#027a39, 0.5);
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-top: 6px solid transparent;
    }
  }

  &.sorting_asc:before {
    border-bottom: 6px solid transparentize(white, 0.5);
  }

  &.sorting_desc:after {
    border-top: 6px solid transparentize(white, 0.5);
  }

  &.no-sort:before,
  &.no-sort:after {
    display: none;
  }
}

.newTable tbody.block-height {
  display: block;
  height: 350px;
  overflow-y: scroll;
  border: 0 !important;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    width: 17px;
    border: 0;
    box-shadow: none;
  }

  &::-webkit-scrollbar-track {
    box-shadow: none;
    border-radius: 0px;
    border: 0;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar-thumb {
    width: 10px;
    border-radius: 20px;
    background-color: #555;
  }
}
</style>
